export enum MY_UPLOADS_SORTING_KEYS {
    CREATED_AT_ASC = 'createdAt-asc',
    WITHOUT = '',
    CREATED_AT_DESC = 'createdAt-desc',
    FREE_DOWNLOADS_ASC = 'freeDownloads-asc',
    FREE_DOWNLOADS_DESC = 'freeDownloads-desc',
    IN_FAVORITES_ASC = 'inFavorites-asc',
    IN_FAVORITES_DESC = 'inFavorites-desc',
    LAST_UPDATED = 'updatedByHumanAt',
    PRICE_ASC = 'price-asc',
    PRICE_DESC = 'price-desc',
    TITLE_ASC = 'title-asc',
    TITLE_DESC = 'title-desc',
    TOTAL_PURCHASES_ASC = 'totalPurchases-asc',
    TOTAL_PURCHASES_DESC = 'totalPurchases-desc',
    TOTAL_REVENUE_ASC = 'totalRevenue-asc',
    TOTAL_REVENUE_DESC = 'totalRevenue-desc'
}

export const MY_UPLOADS_GQL_SORTING_MAP = {
    [MY_UPLOADS_SORTING_KEYS.LAST_UPDATED]: '[{sort: updatedByHumanAt, order: DESC}, { sort: id, order: DESC }]',
    [MY_UPLOADS_SORTING_KEYS.CREATED_AT_DESC]: '[{sort: createdAt, order: DESC}, { sort: id, order: DESC }]',
    [MY_UPLOADS_SORTING_KEYS.CREATED_AT_ASC]: '[{sort: createdAt, order: ASC}, { sort: id, order: ASC }]',
    [MY_UPLOADS_SORTING_KEYS.TOTAL_REVENUE_DESC]: '[{sort: totalRevenue, order: DESC}, { sort: id, order: DESC }]',
    [MY_UPLOADS_SORTING_KEYS.TOTAL_REVENUE_ASC]: '[{sort: totalRevenue, order: ASC}, { sort: id, order: ASC }]',
    [MY_UPLOADS_SORTING_KEYS.TOTAL_PURCHASES_DESC]: '[{sort: totalPurchases, order: DESC}, { sort: id, order: DESC }]',
    [MY_UPLOADS_SORTING_KEYS.TOTAL_PURCHASES_ASC]: '[{sort: totalPurchases, order: ASC}, { sort: id, order: ASC }]',
    [MY_UPLOADS_SORTING_KEYS.FREE_DOWNLOADS_DESC]: '[{sort: freeDownloads, order: DESC}, { sort: id, order: DESC }]',
    [MY_UPLOADS_SORTING_KEYS.FREE_DOWNLOADS_ASC]: '[{sort: freeDownloads, order: ASC}, { sort: id, order: ASC }]',
    [MY_UPLOADS_SORTING_KEYS.IN_FAVORITES_DESC]: '[{sort: inFavorites, order: DESC}, { sort: id, order: DESC }]',
    [MY_UPLOADS_SORTING_KEYS.IN_FAVORITES_ASC]: '[{sort: inFavorites, order: ASC}, { sort: id, order: ASC }]',
    [MY_UPLOADS_SORTING_KEYS.PRICE_DESC]: '[{sort: price, order: DESC}, { sort: id, order: DESC }]',
    [MY_UPLOADS_SORTING_KEYS.PRICE_ASC]: '[{sort: price, order: ASC}, { sort: id, order: ASC }]',
    [MY_UPLOADS_SORTING_KEYS.TITLE_DESC]: '[{sort: title__keyword, order: DESC}, { sort: id, order: DESC }]',
    [MY_UPLOADS_SORTING_KEYS.TITLE_ASC]: '[{sort: title__keyword, order: ASC}, { sort: id, order: ASC }]'
};
